module.exports = __webpack_public_path__ + "img/V-45-ST-550-BB.537d48d2.png";